export default {
  unavailable: {
    title: 'Denne tjeneste drives af Foodamigos',
    description:
      'Print af flyers og klistermærker er en tjeneste, der drives af Foodamigos-teamet, og som ikke er tilgængelig for partnerkonti.',
  },
};
